import React from "react";
import "./Header.css";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

export default function Header({ authenticated }) {
    return (
        <header>
            <div className="header-logo-container">
                <a href="/home">  
                    <div className="logo-container"> 
                        <img alt="Sertify Account" src="https://sert-consumer.s3.amazonaws.com/images/logos/Sertify_logoart_black_whitedoor_RGB.png"/>
                    </div>
                </a>
                {authenticated && (
                    <Navbar>
                        <Nav className="me-auto">
                            <Nav.Link href="/profile">My Profile</Nav.Link>
                            <Nav.Link href="/stamps">Download Sertify Stamps</Nav.Link>
                            <Nav.Link href="/socialcontent">Customize Your Images</Nav.Link>
                            <Nav.Link href="/logout">Sign Out</Nav.Link>
                        </Nav>
                    </Navbar>
                )}
            </div>
        </header>

    );
}